'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactFontawesome = require('react-fontawesome');

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _reactDeviceDetect = require('react-device-detect');

var _wrapper = require('./wrapper');

var _wrapper2 = _interopRequireDefault(_wrapper);

var _dialog = require('./dialog');

var _dialog2 = _interopRequireDefault(_dialog);

var _closeButton = require('./close-button');

var _closeButton2 = _interopRequireDefault(_closeButton);

var _okButton = require('./ok-button');

var _okButton2 = _interopRequireDefault(_okButton);

var _content = require('./content');

var _content2 = _interopRequireDefault(_content);

var _arrowKeys = require('./arrow-keys');

var _arrowKeys2 = _interopRequireDefault(_arrowKeys);

var _fingerDrag = require('./finger-drag');

var _fingerDrag2 = _interopRequireDefault(_fingerDrag);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ScrollingHelper = function (_Component) {
  _inherits(ScrollingHelper, _Component);

  /** @constructor
    * Creates a new instance of the scrolling helper.
    */
  function ScrollingHelper(props) {
    _classCallCheck(this, ScrollingHelper);

    var _this = _possibleConstructorReturn(this, (ScrollingHelper.__proto__ || Object.getPrototypeOf(ScrollingHelper)).call(this, props));

    _this.state = { visible: false };
    return _this;
  }
  /** @method componentDidMount
    * Checks to see if the user has previously seen this hint,
    * and if not, displays it.
    */


  _createClass(ScrollingHelper, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      // Otherwise, check for a session record
      if (!window.vexpo) window.vexpo = {};
      if (!window.vexpo.hints) window.vexpo.hints = {};
      if (!window.vexpo.hints.scrolling) {
        this.setState({ visible: true });
        window.vexpo.hints.scrolling = true;
      }
    }
    /** @method render
      * Renders the overlay.
      */

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var visibleClass = this.state.visible ? 'active' : '';
      return _react2.default.createElement(
        _wrapper2.default,
        { className: visibleClass },
        _react2.default.createElement(
          _dialog2.default,
          null,
          _react2.default.createElement(
            _closeButton2.default,
            { onClick: function onClick() {
                return _this2.setState({ visible: false });
              } },
            'CLOSE',
            _react2.default.createElement(_reactFontawesome2.default, { name: 'times-circle' })
          ),
          _react2.default.createElement(
            _content2.default,
            null,
            _react2.default.createElement(
              'h2',
              null,
              'Hall Navigation'
            ),
            _react2.default.createElement(
              _reactDeviceDetect.BrowserView,
              { device: _reactDeviceDetect.isBrowser },
              _react2.default.createElement(
                'p',
                null,
                'Use the Arrow Keys or scrollbars to navigate the exposition halls.'
              ),
              _react2.default.createElement('img', { src: _arrowKeys2.default, alt: 'arrow keys' })
            ),
            _react2.default.createElement(
              _reactDeviceDetect.MobileView,
              { device: _reactDeviceDetect.isMobile },
              _react2.default.createElement(
                'p',
                null,
                'Drag one finger across the screen to navigate the exposition halls.'
              ),
              _react2.default.createElement('img', { src: _fingerDrag2.default, alt: 'one finger drag' })
            ),
            _react2.default.createElement(
              _okButton2.default,
              { onClick: function onClick() {
                  return _this2.setState({ visible: false });
                } },
              _react2.default.createElement(_reactFontawesome2.default, { name: 'check' }),
              'Got it!'
            )
          )
        )
      );
    }
  }]);

  return ScrollingHelper;
}(_react.Component);

exports.default = ScrollingHelper;


//////////////////
// WEBPACK FOOTER
// ../vexpo-components/build/helpers/scrolling-helper.js
// module id = 1374
// module chunks = 0